import AppLayout from '../Layout/AppLayout';
import ContenuQm from '../Components/Qm/ContenuQm';

const GestionQm = () => {
    return (
        <AppLayout>
            <ContenuQm />
        </AppLayout>
    );
};

export default GestionQm;
